import * as React from 'react';
import styled from 'styled-components';
import { colors } from 'kaizen-ui-colors/lib';
import Project from '../../../domain/entity/Project';
import { RoundStateLabel } from '../RoundStateLabel';
import { RoundTimeline } from '../RoundTimeline';

interface IProps {
  project: Project;
}

const Wrapper = styled.div`
  padding: 16px 20px;
`;

const Heading = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
`;

const RoundNum = styled.span`
  font-weight: 700;
  margin-right: 16px;
`;

const MetricsSection = styled.div`
  margin-bottom: 24px;
`;

const Metrics = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Metric = styled.div`
  width: 50%;
  color: ${colors.ash_dark__878fa0};
  font-size: 12px;
  font-family: Verdana, sans-serif;
`;

export class RoundMonitorRoundOverview extends React.Component<IProps, {}> {
  public render() {
    const { project } = this.props;
    const currentRound = project.round;
    return (
      <Wrapper>
        <Heading>
          <RoundNum>ラウンド {currentRound.num}</RoundNum>
          <RoundStateLabel label={project.projectStateLabel()} bgColor={project.projectStateBgColor()} />
        </Heading>
        <MetricsSection>
          <Metrics>
            <Metric>訪問数: {currentRound.pvPerDay.toLocaleString()}/日</Metric>
            <Metric>
              目標改善率: {currentRound.targetImprovementRate ? `${currentRound.targetImprovementRate}%` : '-'}
            </Metric>
          </Metrics>
          <Metrics>
            <Metric>CV数: {currentRound.cvPerDay.toLocaleString()}/日</Metric>
            <Metric>有意差: {currentRound.competitionDecided ? <strong>あり</strong> : 'なし'}</Metric>
          </Metrics>
        </MetricsSection>
        <RoundTimeline round={currentRound} />
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/presentation/component/RoundMonitor/RoundMonitorRoundOverview.tsx